// zoneOfRelevanceStore
const GET_BRAND = 'getBrand';
const GET_CARDS = 'getCards';
const GET_ZOR_CARDS = 'getZorCards';
const GET_ZOR_TABS = 'getZorTabs';
const GET_INFO = 'getInfo';
const IS_ZONE_OF_RELEVANCE_ENABLED = 'isZoREnabled';
const IS_LOYALTY_FALLBACK = 'isLtyFallback';

// loyaltyStore
const GET_REWARD_POINTS = 'getRewardPoints';

export { GET_BRAND, GET_CARDS, GET_INFO, IS_ZONE_OF_RELEVANCE_ENABLED, GET_ZOR_CARDS, GET_ZOR_TABS, IS_LOYALTY_FALLBACK, GET_REWARD_POINTS };
